import { toast } from '../core/effects';

/** Every arcade minigame, opened by id. Each module registers itself. */
export type GameId =
  | 'volleyball' | 'tennis' | 'rhythm' | 'drawing' | 'racing' | 'circus' | 'minesweeper' | 'snake'
  | 'baseball' | 'maze' | 'match3' | 'puzzle' | 'blocks'
  | 'goldfish' | 'ringToss' | 'claw'
  | 'dragonBoat' | 'stoneStack';

const games = new Map<GameId, () => void>();

export function registerGame(id: GameId, open: () => void): void {
  games.set(id, open);
}

export function openMinigame(id: GameId): void {
  const g = games.get(id);
  if (g) g();
  else toast('🚧');
}
